module.exports = __webpack_public_path__ + "img/review-infinite-marquee.6fe84b12.gif";